function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6569 3.34313C13.1459 1.83213 11.1369 1 9 1C6.86312 1 4.85413 1.83213 3.34313 3.34313C1.83216 4.85413 1 6.86312 1 9C1 11.1369 1.83216 13.1459 3.34313 14.6569C4.85413 16.1679 6.86312 17 9 17C11.1369 17 13.1459 16.1679 14.6569 14.6569C16.1678 13.1459 17 11.1369 17 9C17 6.86312 16.1678 4.85413 14.6569 3.34313ZM9 16.0625C5.10572 16.0625 1.9375 12.8943 1.9375 9C1.9375 5.10572 5.10572 1.9375 9 1.9375C12.8943 1.9375 16.0625 5.10572 16.0625 9C16.0625 12.8943 12.8943 16.0625 9 16.0625Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.6
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.5026 8.53123H8.49841C7.92631 8.53123 7.46091 8.06582 7.46091 7.49376C7.46091 6.92167 7.92634 6.45626 8.49841 6.45626H10.5068C10.7656 6.45626 10.9755 6.24639 10.9755 5.98751C10.9755 5.72864 10.7656 5.51876 10.5068 5.51876H9.46925V4.48126C9.46925 4.22239 9.25938 4.01251 9.0005 4.01251C8.74163 4.01251 8.53175 4.22239 8.53175 4.48126V5.51876H8.49844C7.40941 5.51876 6.52344 6.40476 6.52344 7.49376C6.52344 8.58276 7.40944 9.46873 8.49844 9.46873H9.50263C10.0747 9.46873 10.5401 9.93417 10.5401 10.5062C10.5401 11.0783 10.0747 11.5437 9.50263 11.5437H7.49428C7.23541 11.5437 7.02553 11.7536 7.02553 12.0125C7.02553 12.2714 7.23541 12.4812 7.49428 12.4812H8.53175V13.5188C8.53175 13.7776 8.74163 13.9875 9.0005 13.9875C9.25938 13.9875 9.46925 13.7776 9.46925 13.5188V12.4812H9.5026C10.5916 12.4812 11.4776 11.5952 11.4776 10.5062C11.4776 9.41723 10.5916 8.53123 9.5026 8.53123Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.6
});

function SvgMoneyicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyicon);
export default __webpack_public_path__ + "static/media/money.icon.0bc4442e.svg";
export { ForwardRef as ReactComponent };